import { fastLoanAction } from 'actions/capital';
import {
  ApplicationSentModal,
  Header,
  MenuItem,
} from 'components/CapitalRevamp';
import NoDataAndLoading from 'components/NoDataAndLoading';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import FastLoanTenor from './Tenor/FastLoanTenor';
import FastLoanForm from './FastLoanForm';

class FastLoan extends Component {
  state = {
    showTenor: true,
    form: {},
  };

  componentDidMount() {
    this.props.submissionCheck(browserHistory);
  }

  showModal = () => {
    this.props.setSubmissionModal(true);
  };

  hideModal = () => {
    this.props.setSubmissionModal(false);
    this.props.submissionCheck(browserHistory);
  };

  onTenorSubmit = value => {
    const { form } = this.state;
    this.setState({
      form: { ...form, amount: value.amount, tenor: value.duration },
      showTenor: false,
    });
  };

  onFormSubmit = value => {
    const { form } = this.state;
    const data = {
      commonwealth: {
        ...form,
        ...value,
      },
    };
    this.props.submitForm(browserHistory, data);
  };

  renderContent = () => {
    const { showTenor } = this.state;
    if (showTenor) {
      return <FastLoanTenor onTenorSubmit={this.onTenorSubmit} />;
    }
    return <FastLoanForm onFormSubmit={this.onFormSubmit} />;
  };

  render() {
    const { submissionModal, loadingSpinner } = this.props;
    return (
      <div>
        <Header />
        <MenuItem
          back
          title="Kembali ke Produk"
          onClick={() => browserHistory.push('/capital')}
        />
        {loadingSpinner && <NoDataAndLoading showLoadingSpinner />}
        {!loadingSpinner && this.renderContent()}
        {submissionModal && (
          <ApplicationSentModal
            hideModal={this.hideModal}
            content="Terima kasih telah mengajukan pinjaman di Moka Capital Fast Loan!"
            info="Anda akan menerima Email Notifikasi dalam waktu 2 hari kerja"
            buttonText="Kembali ke halaman Fast Loan"
          />
        )}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setSubmissionModal: value =>
      dispatch(fastLoanAction.setSubmissionModal(value)),
    submissionCheck: value => dispatch(fastLoanAction.submissionCheck(value)),
    submitForm: (history, body) =>
      dispatch(fastLoanAction.submitForm(history, body)),
  };
}

function mapStateToProps(state) {
  const { submissionModal } = state.capital.fastLoan;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    submissionModal,
    loadingSpinner: showLoadingSpinnerPage,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FastLoan);
